export function Download() {
  return (
    <svg
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1518_2035)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1.30899 8.26754C1.75578 8.26754 2.11798 8.62294 2.11798 9.06134V11.8838C2.11798 13.0041 3.04359 13.9124 4.18539 13.9124H12.8146C13.9564 13.9124 14.882 13.0041 14.882 11.8838V9.48471C14.882 9.0463 15.2442 8.6909 15.691 8.6909C16.1378 8.6909 16.5 9.0463 16.5 9.48471V11.8838C16.5 13.881 14.85 15.5 12.8146 15.5H4.18539C2.15001 15.5 0.5 13.881 0.5 11.8838V9.06134C0.5 8.62294 0.862197 8.26754 1.30899 8.26754Z"
          fill="currentColor"
        />
        <path
          d="M5.21196 6.39703C5.51681 6.07653 6.02873 6.05921 6.35536 6.35834L7.69101 7.58155L7.69101 1.29381C7.69101 0.855399 8.05321 0.5 8.5 0.5C8.94679 0.5 9.30899 0.855399 9.30899 1.29381L9.30899 7.58156L10.6446 6.35834C10.9713 6.05921 11.4832 6.07653 11.788 6.39703C12.0929 6.71753 12.0752 7.21984 11.7486 7.51898L9.05199 9.9886C8.74117 10.2733 8.25883 10.2733 7.94801 9.9886L5.25138 7.51897C4.92475 7.21984 4.9071 6.71753 5.21196 6.39703Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_1518_2035">
          <rect
            width="16"
            height="16"
            fill="white"
            transform="translate(0.5 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
